import ItemSelector from "../ItemCatalog/ItemSelector"
import { useContext } from "react"
import CatalogBrowserContext, { CatalogBrowserContextWrapper } from "../ItemCatalog/CatalogBrowserContext"
import { OnTemplateAdd } from "./ItemsRoot"
import CatalogItemHandler from "./CatalogItemHandler"

const InnerReceiptCatalogBrowser = () => {
  const {addCatalogItem, addTemplate, allowDragging} = useContext(CatalogBrowserContext)

  return <div style={{padding: '0 5px'}}>
    <ItemSelector
      onAdd={addCatalogItem}
      onTemplateAdd={addTemplate}
      draggable={allowDragging}
      fixedHeight={'calc(100vh - 60px)'}
      docked
      anchorNewItemModal />
  </div>
}

type Props = {
  onTemplateAdd: OnTemplateAdd
}

const ReceiptCatalogBrowser = ({ onTemplateAdd }:Props) => {
  /*
   * This component needs to render the <CatalogItemHandler> so that the workarea selection modal
   * will appear above the Angularjs Receipt modal correctly (due to HTML/CSS stacking contexts).
   * We nest a separate CatalogBrowserContextWrapper so the handler doesn't steal the other context's itemHandlerRef.
   */
  return <CatalogBrowserContextWrapper allowDragging={false} showTemplates={true} >
    <CatalogItemHandler onTemplateAdd={onTemplateAdd} setLastAddedCatalogItem={() => {}} />
    <InnerReceiptCatalogBrowser/>
  </CatalogBrowserContextWrapper>
}

export default ReceiptCatalogBrowser